//
//
//
//
//
//
//
//
//
//
//

import util from "../../lib/util";

export default {
    name: "serveMsgDetail",
    data() {
        return {
            id: 0,
            content: '',
            contentInfo: {},
            wxReady: false,
            imgList: []
        }
    },
    methods: {
        getGraphicInformationByBusiness() {
            abp.ajax.get('/api/services/app/GraphicInformation/GetGraphicInformationByBusiness?businessId=' + this.id + '&businessType=content.remarks').then(res => {
                this.content = '';
                this.content = res.data.result.content;

            })
        },
        getContentById() {
            const vm = this;
            abp.ajax.get('/api/services/app/Content/GetContentById', {params: {id: vm.id}}).then(res => {
                vm.contentInfo = {};
                vm.contentInfo = res.data.result;
                if (vm.wxReady && vm.contentInfo != null) {

                    vm.imgList = [];
                    vm.contentInfo.remarks.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, function (match, capture) {
                        vm.imgList.push(capture);
                    });

                    wx.updateAppMessageShareData({
                        title: vm.contentInfo.title, // 分享标题
                        desc: vm.contentInfo.description != null ? vm.contentInfo.description : '', // 分享描述
                        link: util.BaseUrl + '#/serveMsgDetail/' + vm.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: vm.imgList.length > 0 ? vm.imgList[0] : '', // 分享图标
                        success: function () {
                            // 设置成功
                        }
                    })

                    wx.updateTimelineShareData({
                        title: vm.contentInfo.title, // 分享标题
                        link: util.BaseUrl + '#/serveMsgDetail/' + vm.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: vm.imgList.length > 0 ? vm.imgList[0] : '', // 分享图标
                        success: function () {
                            // 设置成功
                        }
                    })
                }
            }).finally(() => {
                if (this.contentInfo && this.contentInfo.title.length > 0) {
                    window.document.title = this.contentInfo.title;
                    util.title(this.contentInfo.title)
                }
            })
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        this.getContentById();
        this.getGraphicInformationByBusiness();
    },
    mounted() {
        const vm = this;
        abp.ajax.get(util.ApiUrl + "api/services/app/WeiXin/GetSingture?url=" + encodeURIComponent(location.origin + location.pathname)).then(result => {
            let configModel = result.data.result;
            wx.config({
                appId: configModel.appId,
                timestamp: configModel.timestamp,
                nonceStr: configModel.nonceStr,
                signature: configModel.signature, // 必填，签名
                jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"]
            });
            wx.ready(() => {
                vm.wxReady = true;
            });
            wx.error(res => {
                vm.wxReady = false;
            });
        });
    }
}
